import { MOCK_LIFESTYLE_WINNERS } from "./mocks/lifestyleWinners";
import { MOCK_SUPER_CAR_PRIZE_DETAILS } from "./mocks/superCarPrizeDetails";
import { LifestyleWinnersResponse, SuperCarPrizeDetails } from "./types";

/** Flip to false when GetSuperCarPrizeDetails / GetLifestyleWinners are live on the env. */
const USE_MOCKS = false;

const mockJsonResponse = <T>(data: T) =>
  Promise.resolve({
    ok: true,
    json: () => Promise.resolve(data),
  } as Response);

export const getPrizeMediaCarousel = async (prizeId: number) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prize/GetPrizeMediaCarousel?prizeId=${prizeId}`);

export const getSuperCarPrizeDetails = async (prizeId: number): Promise<Response> => {
  if (USE_MOCKS) {
    return mockJsonResponse<SuperCarPrizeDetails>(MOCK_SUPER_CAR_PRIZE_DETAILS);
  }

  return fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetSuperCarPrizeDetails?prizeid=${prizeId}`);
};

let lifestyleWinnersPromise: Promise<LifestyleWinnersResponse> | null = null;

export const getLifestyleWinners = async (competitionTypePrefix: string = "XC"): Promise<LifestyleWinnersResponse> => {
  if (USE_MOCKS) {
    return MOCK_LIFESTYLE_WINNERS;
  }

  if (!lifestyleWinnersPromise) {
    lifestyleWinnersPromise = fetch(
      `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetLifestyleWinners?competitionTypePrefix=${competitionTypePrefix}`
    )
      .then(async res => {
        if (!res.ok) {
          throw new Error(`GetLifestyleWinners failed with status ${res.status}`);
        }
        return (await res.json()) as LifestyleWinnersResponse;
      })
      .catch(err => {
        lifestyleWinnersPromise = null;
        throw err;
      });
  }

  return lifestyleWinnersPromise;
};
